import { Injectable } from '@angular/core';
import { TranslationService } from './translation.service';
@Injectable()
export class LayoutTranslationService {

  constructor(private translationService: TranslationService) { }

  getLayoutTranslation(val: string, locale: string) {

    const translation = this.translationService.getResourceStringTranslation(val, locale);

    if (!!translation && translation !== val) {
      return translation;
    }

    if (locale === 'en') {
      return val;
    }
    
    console.error("could not find a translation for", val);
    return "";
  }

  getNavLabelTranslation(val: string, locale: string) {

    const translation = this.translationService.getResourceStringTranslation(val, locale);

    if (!!translation && translation !== val) {
      return translation;
    }

    if (locale === 'en') {
      return val;
    }

    console.error("could not find a translation for", val);
    return "";
  }
}

